import Button from "@/components/Button";
import NavigationContainer from "@/containers/layout/NavigationBarContainer";
import { BackUseIcon, ShareUseIcon } from "@/containers/layout/NavigationIcons";
import { ossFullUrl } from "@/utils/getFullWebCdnUrl";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import bridge from "@/utils/dsBridge";
import { BridgeCallHandlers } from "@/interfaces/enums";

export default function IdeasSuccess(props: { onShare: () => void }) {
	const { t } = useTranslation("survey-register");

	const onConfirm = () => {
		bridge.call(BridgeCallHandlers.ON_CLOSE_WEB_PAGE);
	};
	return (
		<NavigationContainer
			showNavigationBar={true}
			navigation={{
				title: t("SURVEY_REG_BOBBY_BETA_TEST_REGISTRATION"),
				leading: [<BackUseIcon key="back" backType="close" />],
				trailing: [<ShareUseIcon key="share" onClick={props.onShare} />],
			}}
			footer={
				<div className="px-5 py-4 rf-page-ani rf-page-ani-delay-4">
					<Button block onClick={onConfirm} id="confirm">
						{t("SURVEY_REG_COMPLETED")}
					</Button>
				</div>
			}
		>
			<div className="px-4.5">
				<p className="pt-7 header-1 rf-page-ani rf-page-ani-delay-0">{t("SURVEY_REG_REGISTRATION_SUCCESSFUL")}</p>

				<p className="mt-4 text-sm inter-text rf-page-ani rf-page-ani-delay-1">
					{t("SURVEY_REG_BETA_TESTING_ROLL_OUT")}
				</p>
				<p className="mt-1.5 text-sm inter-text rf-page-ani rf-page-ani-delay-2">
					{t("SURVEY_REG_SHARE_AND_UPLOAD_SCREENSHOT")}
				</p>

				<div className="mt-[9vh] text-center rf-page-ani rf-page-ani-delay-3">
					<Image
						src={ossFullUrl("/survey/register/success.png")}
						width={254}
						height={282}
						alt="success"
						priority={true}
						className="block mx-auto"
					/>
				</div>
			</div>
		</NavigationContainer>
	);
}
